import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36e77fc8&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SectionEntityGrid: require('/var/www/tourism-front.visit-hm.ru/releases/28/components/common/SectionEntityGrid/index.vue').default})
